












import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import StringUtils from '@/helpers/stringUtils';
import Component from 'vue-class-component';
import { GChart } from 'vue-google-charts/legacy';
import { Prop, Watch } from 'vue-property-decorator';

@Component({
  components: {
    GChart,
    ListMessages
  }
})
export default class InstitutionTop10Chart extends BaseComponent {
  @Prop()
  kpis: any[];

  @Prop()
  total: number;

  @Prop()
  keyValue: number;

  chartData: any[] = [];
  chartOptions: any = {};

  mounted() {
    this.load();
    this.buildChartOptions();
  }

  buildChartOptions() {
    if (!this.kpis) {
      return;
    }
    let kpisUse = this.kpis;
    let paddingHeight = 10;
    let rowHeight = kpisUse.length * 25;
    let chartHeight = rowHeight + paddingHeight;

    if (chartHeight < 100) {
      chartHeight = 100;
    }

    this.chartOptions = {
      tooltip: {
        isHtml: true
      },
      height: chartHeight,
      backgroundColor: 'transparent',
      chartArea: { left: '250', top: '0', right: '70', bottom: '50', height: rowHeight },
      legend: { position: 'bottom' },
      isStacked: false,
      fontSize: 12,
      colors: ['#1F4E79']
    };
  }

  load() {
    if (!this.kpis) {
      return;
    }
    this.chartData = [];
    let kpisUse = this.kpis;

    this.chartData.push([
      'Instituição',
      'Prescrições (% carteira)',
      { role: 'annotation' },
      {
        type: 'string',
        role: 'tooltip',
        p: { html: true }
      }
    ]);
    kpisUse.forEach((i) => {
      this.chartData.push([
        `${StringUtils.abbreviate(i.nome, 30, false)} `,
        i.valor,
        this.getAnnotation(i),
        this.getTooltip(i)
      ]);
    });
  }

  getAnnotation(i) {
    return `${i.valor} (${this.decimalFormatHelper((i.valor / this.total) * 100, 1)}%)`;
  }

  getTooltip(i) {
    return `<div style="padding:8px; white-space:nowrap""><b>${i.nome}</b><br>Quantidade: <b>${this.getAnnotation(
      i
    )}</b></div>`;
  }

  @Watch('kpis', { immediate: true })
  kpisWatch(v) {
    if (!v) {
      return;
    }
    this.buildChartOptions();
    this.load();
  }
}
